// extracted by mini-css-extract-plugin
module.exports = {"percentileSummary":"PercentileSummary_percentileSummary__2HDvO","composite":"PercentileSummary_composite__YE9OF","sections":"PercentileSummary_sections__2XKTq"};